// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line camelcase
import { diff_match_patch } from 'diff-match-patch';
import { br2nl, nl2br } from './util';
import { timeChart } from './UI/highcharts/time-chart';
import { dateFormatter } from './UI/highcharts/utils';

/**
 * Product detail - show / hide reimbursement requirements
 */
(function ($) {
	$('.reimbursement-requirements-form-list label input').on('change', function () {
		let el = $(this),
			id = el.attr('id');

		if (el.is(':checked')) {
			$('#' + id + '-content').addClass('items-act');
		} else {
			$('#' + id + '-content').removeClass('items-act');
		}
	});

	$('.reimbursement-requirements .items').each(function () {
		let items = $(this),
			id = items.attr('id'),
			subid = id.substring(0, id.indexOf('-content'));

		$(this)
			.find('.h4-title')
			.on('click', function () {
				$('.reimbursement-requirements-form #' + subid).trigger('click');
			});
	});

	$('.btn-reimbursement-all').on('click', function () {
		let btnAll = $(this);

		if (btnAll.hasClass('show-reimbursement-all')) {
			btnAll.removeClass('show-reimbursement-all');

			$('.reimbursement-requirements-form-list input').each(function () {
				if (this.checked !== false) {
					$(this).trigger('click');
				}
			});
		} else {
			btnAll.addClass('show-reimbursement-all');

			$('.reimbursement-requirements-form-list input').each(function () {
				if (this.checked !== true) {
					$(this).trigger('click');
				}
			});
		}
	});
})(jQuery);

/**
 * Product detail - toggle SCUP - displaying only warnings / everything
 */
(function ($) {
	$(document).on('click', '.show-only-warnings-toggle', function () {
		var btn = $(this);
		var parent = btn.parent();
		var currentText;

		if (btn.hasClass('show-everything')) {
			currentText = btn.text();
			btn.removeClass('show-everything');
			btn.addClass('show-warnings');
			btn.text(btn.data('alternativeText'));
			btn.data('alternativeText', currentText);

			if ($('.last-notion-changed').length === 0 && $('.next-month-proposed-changed').length === 0) {
				parent.find('.nothing-changed').show();
			}

			parent.find('.table-group tbody tr').not('.last-notion-changed, .next-month-proposed-changed').hide();
			parent.find('.table-group').hide();
			parent.find('.table-group .last-notion-changed, .table-group .next-month-proposed-changed').each(function () {
				$(this).parents('table').show();
			});
		} else {
			currentText = btn.text();
			btn.removeClass('show-warnings');
			btn.addClass('show-everything');
			btn.text(btn.data('alternativeText'));
			btn.data('alternativeText', currentText);
			parent.find('.nothing-changed').hide();

			$('.table-group tr').show();
			$('.table-group').show();
		}
	});
})(jQuery);

/**
 * Product detail - reimbursement requirements toggle showing diff
 */
(function ($) {
	var productWithoutReimbursementRequirementsText = 'Přípravek byl ve SCAU, ale neměl podmínky úhrady';
	var productWithoutScauText = 'Přípravek nebyl uveden ve SCAU / neměl platnou registraci';

	function highlightChanges(oldText, currentText, div) {
		if (oldText === productWithoutReimbursementRequirementsText || oldText === productWithoutScauText) {
			oldText = currentText;
		}

		if (currentText === productWithoutReimbursementRequirementsText || currentText === productWithoutScauText) {
			oldText = currentText;
		}

		var diffMatchPattern = new diff_match_patch();
		// eslint-disable-next-line camelcase
		diffMatchPattern.Diff_Timeout = 1.0;

		var diff = diffMatchPattern.diff_main(oldText, currentText);
		diffMatchPattern.diff_cleanupSemantic(diff);

		var diffOutput = nl2br(diffMatchPattern.diff_prettyHtml(diff)).replace(/&para;/g, ''); // diff_match_patch creates paragraph marks, I don't like that
		div.html(diffOutput);
	}

	$(document).on('click', '#highlight-reimbursement-requirements-diff-toggle', function () {
		$('.items .item').each(function () {
			var reimbursement = $(this).parents('.items');
			var item = $(this);

			var i = item.data('i');
			var diff = item.find('.diff');
			var currentParagraph = item.find('.original');
			var currentText = br2nl(currentParagraph.html());

			var oldParagraph = reimbursement.find(`div[data-i=${i + 1}] .original`);
			var oldText = oldParagraph.length ? br2nl(oldParagraph.html()) : productWithoutScauText;

			highlightChanges(oldText, currentText, diff);
		});

		if ($(this).hasClass('show-everything')) {
			$(this).removeClass('show-everything');
			$(this).addClass('show-warnings');
			$('.items .original').hide();
			$('.items .diff').show();
		} else {
			$(this).removeClass('show-warnings');
			$(this).addClass('show-everything');
			$('.items .original').show();
			$('.items .diff').hide();
		}

		return false;
	});
})(jQuery);

/**
 * Product detail - timeline
 */
(function ($) {
	if (!window.productTimelineData) {
		return;
	}

	timeChart(window.productTimelineData, dateFormatter, 'date-range-chart', {
		exportFilename: 'lp-timeline',
		unit: '\u00A0Kč',
	});
})(jQuery);
